import { useState } from 'react';

/**
 * Hook per gestire gli stati e le azioni dei drawer
 * Estratto da ModelsTableColumnPackage per evitare duplicazione
 */
export const usePackageDrawers = () => {
    const [isOpenModelBooksDrawer, setIsOpenModelBooksDrawer] = useState(false);
    const [modelId, setModelId] = useState();
    const [isMediaDrawer, setIsMediaDrawer] = useState(false);

    const handleOpenModelBooksDrawer = (modelId) => {
        setModelId(modelId);
        setIsOpenModelBooksDrawer(true);
    };

    const handleCloseModelBooksDrawer = () => {
        setIsOpenModelBooksDrawer(false);
        setModelId();
    };

    const handleOpenAddMediaDrawer = (modelId) => {
        setModelId(modelId);
        setIsMediaDrawer(true);
    };

    const handleCloseAddMediaDrawer = () => {
        setIsMediaDrawer(false);
        setModelId();
    };

    const openBooksDrawer = (modelID) => {
        handleOpenModelBooksDrawer(modelID);
    };

    return {
        // States
        isOpenModelBooksDrawer,
        modelId,
        isMediaDrawer,

        // Actions
        handleOpenModelBooksDrawer,
        handleCloseModelBooksDrawer,
        handleOpenAddMediaDrawer,
        handleCloseAddMediaDrawer,
        openBooksDrawer,
    };
};
